import styled from "styled-components"

export const TocContentContainer = styled.div`
  display: ${({ isOpen }) => (isOpen ? "block" : "none")};
  padding: ${({ isOpen }) => (isOpen ? "0 40px 30px 40px" : "0px")};
  li {
    padding-left: 10px;
    margin-right: 30px;
    margin-bottom: 10px;
  }
  ul {
    margin: 0px;
  }

  ul li {
    font-weight: 700;
  }
  ul ul {
    /* we don't want the bullet point for the nested list */
    /* list-style-type: none; */
    margin: 5px 0 10px;
    padding-left: 20px;
  }
  ul ul li {
    margin-bottom: 4px;
    padding-left: 9px;
    /* we don't want the nested list to be bolded */
    font-weight: 400;
  }

  @media screen and (max-width: 768px) {
    padding: ${({ isOpen }) => (isOpen ? "0 20px 20px 20px" : "0px")};
    li {
      font-size: 18px;
      margin-bottom: 5px;
    }
    ul {
      padding-left: 20px;
    }
  }
`

export const TocToggleContainer = styled.div`
  padding: ${({ isOpen }) => (isOpen ? "40px 40px 30px 40px" : "40px")};
  @media screen and (max-width: 768px) {
    padding: ${({ isOpen }) => (isOpen ? "30px 20px 14px 20px" : "30px 20px")};
  }
  h2 {
    margin: 0 0px 0 0;
    ${({ theme: { typography } }) => typography.desktop.h5};
    color: ${({ theme: { colors } }) => colors.accentBlue};
    @media screen and (max-width: 768px) {
      ${({ theme: { typography } }) => typography.mobile.h5};
      color: ${({ theme: { colors } }) => colors.accentBlue};
    }
  }
  @media (hover: hover) {
    :hover {
      cursor: pointer;
      & span {
        background-color: ${({ theme: { colors } }) => colors.accentBlue};
        color: ${({ theme: { colors } }) => colors.white};
      }
      & path {
        stroke: #fff;
      }
    }
  }
  span {
    width: 40px;
    height: 40px;
    position: absolute;
    top: 30px;
    right: 30px;
    border: 1px solid #551bfb;
    border-radius: 50%;
    cursor: pointer;
    color: ${({ theme: { colors } }) => colors.accentBlue};
    transition: all 0.2s ease-in-out;

    @media screen and (max-width: 768px) {
      width: 25px;
      height: 25px;
      right: 20px;
      top: 25px;
    }
  }
  svg {
    top: 2px;
    right: 1.2px;
    width: 35px;
    height: 35px;
    padding: 20%;
    position: absolute;
    transform: scaleY(1);
    transition: transform 0.3s ease-in-out;
    &.down {
      transform: scaleY(-1);
    }

    @media (hover: hover) {
      :hover {
        & path {
          stroke: #fff;
        }
      }
    }

    & path {
      stroke: #4c0ffb;
    }
    @media screen and (max-width: 768px) {
      transition: transform 0.1s ease-in-out;
      padding: 40%;
      top: -3px;
      right: -4px;
      width: 30px;
      height: 30px;
    }
  }
`

export const TocContainer = styled.div`
  margin: 10px 0 60px;
  border-radius: 25px;
  background: ${({ theme: { colors } }) => colors.lightGrey};
  position: relative;
  /* follow the breakpoints and styling from blog post CTA */
  @media only screen and (min-width: 1251px) {
    width: 134%;
    margin-left: -17%;
    margin-right: -17%;
  }

  @media only screen and (max-width: 760px) {
    width: 106%;
    margin-left: -3%;
    margin-right: -3%;
    margin-top: 30px;
  }

  @media only screen and (max-width: 480px) {
    width: 113%;
    margin-left: -6.5%;
    margin-right: -6.5%;
  }
`
